import React, { useEffect, useState } from 'react';
import { CurrencyConverter } from './components/CurrencyConverter';
import { Login } from './components/Login';
import { LogOutIcon } from 'lucide-react';
// Set your password here
const CORRECT_PASSWORD = 'currency2025';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Check if user is already logged in
    const authStatus = localStorage.getItem('currencyConverterAuth');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);
  const handleLogin = (password: string) => {
    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      localStorage.setItem('currencyConverterAuth', 'true');
    } else {
      alert('Incorrect password. Please try again.');
    }
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('currencyConverterAuth');
  };
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen bg-gray-50" data-id="element-0">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" data-id="element-1"></div>
      </div>;
  }
  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} data-id="element-2" />;
  }
  return <div className="flex flex-col w-full min-h-screen bg-gray-50" data-id="element-3">
      <header className="bg-blue-600 text-white p-4 shadow-md" data-id="element-4">
        <div className="container mx-auto flex justify-between items-center" data-id="element-5">
          <div data-id="element-6">
            <h1 className="text-2xl font-bold" data-id="element-7">
              Currency Converter Spreadsheet
            </h1>
            <p className="text-sm" data-id="element-8">GBP to AUD with Real-Time Exchange Rates</p>
          </div>
          <button onClick={handleLogout} className="flex items-center px-4 py-2 bg-blue-700 hover:bg-blue-800 rounded-lg transition-colors" title="Logout" data-id="element-9">
            <LogOutIcon size={18} className="mr-2" data-id="element-10" />
            Logout
          </button>
        </div>
      </header>
      <main className="flex-1 container mx-auto p-4 md:p-8" data-id="element-11">
        <CurrencyConverter data-id="element-12" />
      </main>
      <footer className="bg-gray-100 p-4 text-center text-gray-600 text-sm border-t" data-id="element-13">
        <p data-id="element-14">
          Exchange rates are updated every minute. Data provided by
          ExchangeRate-API.
        </p>
      </footer>
    </div>;
}